module.exports = __webpack_public_path__ + "static/media/ThumbsDown.7b99b585.svg";